import { defineComponent as _defineComponent } from 'vue'
import PaginatedNotifications from 'bd-common/src/components/notifications/PaginatedNotifications.vue';
import { useRoute, useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadsView',
  setup(__props) {

const router = useRouter();

const route = useRoute();

function goBack() {
  const fromRoute = route.query?.fromRoute;

  router.push({
    path: typeof fromRoute === 'string' ? fromRoute : '/app/dashboard',
  });
}

return { __sfc: true,router, route, goBack, PaginatedNotifications }
}

})